<template>
  <div class="col-12">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-10 col-lg-6">
        <div class=" row text-center ml-5">
          <div class="mb-5">
            <img src="../../assets/tn_cybertech_grad_logo.png" class="tn-logo" style="width: 200px; height: auto;">
          </div>
          <p class="text-muted mt-4">Please read and accept the terms and conditions!</p>
        </div>
        <div class="ui fitted divider mt-2"></div>
      </div>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-3">
      <div class="col-11 col-lg-9">
        <div class="ui violet floating message m-4" style="float:left;overflow-y: auto;height: 500px;">
          <div class="header mb-2">
            TN CyberTech Bank
          </div>
          <p>I/We the undersigned, having applied for a bank account or sanctioned or/and unsanctioned facility or
            EcoCash Banking services or SMS Alert facility or Local and /or lnternational Card services or
            Internet Banking services with TN CyberTech Bank Limited do hereby acknowledge and accept the following terms and
            conditions
            <br /><br />

            ~ Interest on any debit balance on the account shall be calculated and compounded daily at the same nominal
            rate as that applicable to the capital amount. In the event that no such rate has been
            communicated to me in writing, the Bank’s prevailing rate charged on Unsanctioned facilities plus a
            prevailing premium of the nominal rate shall apply.

            <br /><br />

            ~ Any interest charges debited to my account shall be immediately due for payment on the date of the debit,
            and where the amount is not paid; it shall itself accrue further interest at the same
            nominal rate as the capital amount.
            <br /><br />
            ~ Any payments made to my account shall first be appropriated towards interest, then towards bank charges
            and then towards capital starting with the oldest capital debts.
            <br /><br />
            ~ In the event that any interest charges remain unpaid a day after they become due for payment, I confirm
            that any borrowing incurred by the Bank to square its position in respect of the amount
            of the loan, whether such borrowing is from the market ,or from the shareholders ‘ funds, is a borrowing on
            my account, and that consequently, the amount of the unpaid interest remaining
            outstanding each day shall be a new advance by the Bank to me from such funds used by the Bank to square its
            position. For the purpose of convenience I hereby waive my entitlement to any
            loan documentation, or any communication whatsoever regarding that new loan, the mere existence of an
            interest charge against my account being conclusive evidence of the existence of such
            loan.
            <br /><br />
            ~ Where the actual interest amount incurred on a daily basis is not debited to my account, I confirm that it
            shall be my duty to establish the extent of such interest amount on a daily basis, and I
            confirm that the amount of such interest not debited to my account daily shall be treated as if it had been
            so debited, and, in which event it shall be novated in accordance with the provisions of
            clause d) hereof.
            <br /><br />
            ~ I /We agree that the Bank reserves the right to close my/our account compulsorily without warning if it is
            unsatisfactorily conducted. I/We also certify that the above statements in support of
            the my /our bank account application are true and complete, and understand that in the event of any
            information proving to be incorrect, this application may be declined.
            <br /><br />

            ~ I /We do hereby advise , state and declare that I/We are not involved in Internet Gambling, or provide
            support or infrastructure to Internet Gambling entities. I /We undertake to advise the Bank
            forthwith should the declared position and status change
            <br /><br />
            ~ I/We indemnify the Bank against any damage, loss, and /or consequential damage that the Bank may suffer as
            a result of incorrect, wrong, unauthorised and /or wrongful instructions or
            information given by us or any other person authorised or deemed to be authorised to act on behalf of our
            corporate entity.
            <br /><br />
            ~ I/We hereby certify that all the information provided is correct and I authorise TN CyberTech Bank to use the
            information contained herein to open a selected bank
            account and link the account to selected banking services including EcoCash, SMS facility, internet banking
            services.
            <br /><br />
            ~ I /We hereby indemnify TN CyberTech Bank Limited against any Losses, claims, damages, whether direct, special,
            or consequential, howsoever and when so ever arising as a result of failure of mobile
            equipment, EcoCash Banking or SMS Alert or Internet Banking Services being offline or unavailable for any
            reason, mobile number provided being incorrect, unlawful or unauthorised access to
            my phone by another person, delays in electronic banking delivery channel direct or indirect losses which
            the Bank could not reasonably have foreseen.
            <br /><br />
            ~ I/We undertake to notify the Bank within 24 hours of any changes to my mobile number or bank account
            number or in the event that my mobile handset is Lost or stolen.
            <br /><br />
            ~ My PIN or password to EcoCash Banking Services, Internet Banking, and another electronic delivery product
            shall not be disclosed to third party under any circumstances whatsoever and I agree
            that the Bank shall not be liable of any nature whatsoever should I disclose pin or password to the third
            party.
            <br /><br />
            ~ The above terms and conditions shall be read together with other terms and conditions as they appear on
            any other Banking Services Guidelines or forms as advised by the Bank from time to
            time.
            <br /><br />
            ~ The Bank reserves the right, from time to time, to review and /or amend the terms and conditions
            applicable to the use of Banking Services on EcoCash, Internet, SMS Alert facility or any other
            banking delivery channel and shall advise the customer of the changes accordingly.
            <br /><br />
            ~ I/We hereby agree to the Terms and Conditions as published from time to time by EcoCash(r), EcoSure(r) and
            Steward Health. I/We hereby nominate the following as beneficiary for Ecosure Funeral.
          </p>
        </div>
        <div class="mt-5">
          <button class="ui button large basic purple fluid mt-4" @click="next()" type="submit">Agree</button>
          <button class="ui button large basic grey fluid mt-3 mb-4" @click="back()">Back</button>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";

export default {
  name: 'TermsAndConditions',
  data() {
    return {
      customer: {
        mobileNumber: ""
      },
      errors: {},
      operations: 0,
    };
  },
  mounted() {
    // Component ready
  },
  methods: {
    next() {
      this.$router.push("/omni/account-type");
    },
    back() {
      this.$router.push("/omni/home");
    },
    ...baseMethods,
  }
};
</script>